
import React from 'react';

const BrandFooter: React.FC = () => {
  return (
    <footer className="w-full py-3 text-center text-gray-400 dark:text-gray-500 text-xs border-t dark:border-gray-800 bg-white dark:bg-gray-950 fixed bottom-0 left-0 right-0 z-50 transition-colors">
      <div className="flex items-center justify-center gap-3">
        <span className="text-[10px] font-bold uppercase tracking-widest opacity-50 dark:opacity-70">Powered by</span>
        <img src="/maghil-hub-logo.png" alt="Maghil Hub" className="h-5 w-auto object-contain" />
      </div>
    </footer>
  );
};

export default BrandFooter;
